/**
 * Studio/Work hub — mobile nav accordion, cover hover cycle,
 * and Filter + drawer (scope / venue) on service pages.
 */
(function () {
  'use strict';

  function initNav(root) {
    var toggle = root.querySelector('[data-ode-work-nav-toggle]');
    var nav = root.querySelector('[data-ode-work-nav]');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function () {
      var open = nav.getAttribute('data-open') === 'true';
      nav.setAttribute('data-open', open ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  }

  function advance(panel) {
    var current = parseInt(panel.dataset.state, 10) || 0;
    var max = parseInt(panel.dataset.frameCount, 10) || 1;
    if (max <= 1) return;
    panel.classList.add('transitioning');
    panel.dataset.state = String((current + 1) % max);
  }

  function initCycle(root) {
    var panels = Array.prototype.slice.call(root.querySelectorAll('.ode-ps__panel.has-cycle'));
    if (panels.length === 0) return;

    var hasHover = window.matchMedia('(hover: hover)').matches;

    panels.forEach(function (panel) {
      if (hasHover) {
        panel.addEventListener('mouseenter', function () {
          advance(panel);
        });
      }
    });
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function initPropertyFilters(root) {
    if (root.getAttribute('data-property-filters') !== 'true') return;
    if (root.getAttribute('data-filters-bound') === 'true') return;

    var triggerSample = root.querySelector('[data-scope-filter-trigger]');
    var panelId = triggerSample && triggerSample.getAttribute('aria-controls');
    var filterPanel =
      (panelId && document.getElementById(panelId)) ||
      root.querySelector('[data-service-filter-panel]');
    var scopeFilterBackdrop =
      root.querySelector('[data-scope-filter-backdrop]') ||
      document.querySelector(
        '[data-scope-filter-backdrop][data-filter-for="' + (root.id || '') + '"]'
      );
    if (!filterPanel) return;

    /* Hoist above Studio Ode header (Orders, z-index 9999). Nested fixed
       panels lose to the header stacking context otherwise. */
    if (scopeFilterBackdrop && scopeFilterBackdrop.parentNode !== document.body) {
      if (root.id) scopeFilterBackdrop.setAttribute('data-filter-for', root.id);
      document.body.appendChild(scopeFilterBackdrop);
    }
    if (filterPanel.parentNode !== document.body) {
      document.body.appendChild(filterPanel);
    }

    root.setAttribute('data-filters-bound', 'true');

    var tagNav = filterPanel.querySelector('[data-property-tag-nav]');
    var venueTagNav = filterPanel.querySelector('[data-venue-tag-nav]');
    var filterControls = root.querySelector('[data-filter-controls]');
    var appliedFiltersEl = root.querySelector('[data-applied-filters]');
    var appliedListEl = root.querySelector('[data-applied-list]');
    var scopeFilterTriggers = root.querySelectorAll('[data-scope-filter-trigger]');
    var scopeFilterClose = filterPanel.querySelector('[data-scope-filter-close]');
    var filterClearBtn = filterPanel.querySelector('[data-filter-clear]');
    var filterApplyBtn = filterPanel.querySelector('[data-filter-apply]');
    var gallery = root.querySelector('[data-service-gallery]');
    var emptyEl = root.querySelector('[data-gallery-empty]');
    var items = gallery
      ? Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-item]'))
      : [];
    var mobileScopeQuery = window.matchMedia('(max-width: 749px)');
    var filtersAvailable = true;
    var lastFilterTrigger = null;
    var allowVenue = root.getAttribute('data-filter-has-venue') === 'true';

    var params = new URLSearchParams(window.location.search);
    var activeScopeFilters = params.getAll('scope').filter(Boolean);
    var activeVenueFilters = allowVenue ? params.getAll('venue').filter(Boolean) : [];
    var pendingScopeFilters = activeScopeFilters.slice();
    var pendingVenueFilters = activeVenueFilters.slice();

    function isFilterModalOpen() {
      return filterPanel.getAttribute('data-filter-open') === 'true';
    }

    function activeFilterCount() {
      return activeScopeFilters.length + activeVenueFilters.length;
    }

    function syncFilterGroupState(nav, activeList) {
      if (!nav) return;
      nav.querySelectorAll('.ode-work-hub__tag').forEach(function (tag) {
        var filterValue = tag.getAttribute('data-tag-value');
        var isActive = activeList.indexOf(filterValue) !== -1;
        tag.classList.toggle('is-active', isActive);
        tag.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        if (isActive) {
          tag.setAttribute('aria-current', 'true');
        } else {
          tag.removeAttribute('aria-current');
        }
      });
    }

    function syncDrawerFilterState() {
      syncFilterGroupState(tagNav, pendingScopeFilters);
      syncFilterGroupState(venueTagNav, pendingVenueFilters);
    }

    function syncFilterChrome() {
      var count = activeFilterCount();
      var mobile = mobileScopeQuery.matches;

      scopeFilterTriggers.forEach(function (trigger) {
        var variant = trigger.getAttribute('data-filter-trigger-variant');
        var show = filtersAvailable && (variant === 'sticky' ? mobile : !mobile);
        var countEl = trigger.querySelector('[data-filter-count]');

        trigger.hidden = !show;
        trigger.classList.toggle('is-active', count > 0);
        trigger.setAttribute('aria-expanded', isFilterModalOpen() ? 'true' : 'false');

        if (variant === 'sticky') {
          if (countEl) {
            if (count > 0) {
              countEl.textContent = ' (' + count + ')';
              countEl.hidden = false;
            } else {
              countEl.textContent = '';
              countEl.hidden = true;
            }
          }
          trigger.setAttribute('aria-label', count > 0 ? 'Filter (' + count + ')' : 'Filter');
        }
      });

      if (filterControls) {
        filterControls.hidden = !filtersAvailable;
      }

      filterPanel.setAttribute('aria-hidden', isFilterModalOpen() ? 'false' : 'true');
    }

    function renderAppliedFilters() {
      if (!appliedListEl || !appliedFiltersEl) return;

      var chips = [];
      function pushChip(kind, slug, nav) {
        var btn = nav && nav.querySelector('[data-tag-value="' + slug + '"]');
        var label = (btn && btn.getAttribute('data-tag-label')) || slug;
        chips.push({ kind: kind, slug: slug, label: label });
      }

      activeScopeFilters.forEach(function (slug) {
        pushChip('scope', slug, tagNav);
      });
      activeVenueFilters.forEach(function (slug) {
        pushChip('venue', slug, venueTagNav);
      });

      if (chips.length === 0) {
        appliedFiltersEl.hidden = true;
        appliedListEl.innerHTML = '';
        return;
      }

      appliedFiltersEl.hidden = false;
      appliedListEl.innerHTML = chips
        .map(function (chip) {
          return (
            '<li>' +
            '<button type="button" class="ode-work-hub__applied-chip" data-remove-filter="' +
            chip.kind +
            '" data-filter-value="' +
            escapeHtml(chip.slug) +
            '" aria-label="Remove ' +
            escapeHtml(chip.label) +
            '">' +
            '<span class="ode-work-hub__applied-chip-label">' +
            escapeHtml(chip.label) +
            '</span>' +
            '<span class="ode-work-hub__applied-chip-remove" aria-hidden="true">&times;</span>' +
            '</button>' +
            '</li>'
          );
        })
        .join('');
    }

    function itemMatches(item) {
      var scopes = (item.getAttribute('data-scopes') || '')
        .split(',')
        .map(function (s) {
          return s.trim();
        })
        .filter(Boolean);
      var venue = (item.getAttribute('data-venue') || '').trim();

      if (activeScopeFilters.length > 0) {
        var scopeOk = activeScopeFilters.some(function (slug) {
          return scopes.indexOf(slug) !== -1;
        });
        if (!scopeOk) return false;
      }

      if (activeVenueFilters.length > 0) {
        if (!venue || activeVenueFilters.indexOf(venue) === -1) return false;
      }

      return true;
    }

    function applyGalleryFilter() {
      var visible = 0;
      items.forEach(function (item) {
        var show =
          activeScopeFilters.length === 0 && activeVenueFilters.length === 0
            ? true
            : itemMatches(item);
        item.hidden = !show;
        if (show) visible += 1;
      });
      if (emptyEl) {
        emptyEl.hidden = visible > 0 || items.length === 0;
      }
    }

    function updateFilterUrl() {
      var search = new URLSearchParams();
      activeScopeFilters.forEach(function (slug) {
        search.append('scope', slug);
      });
      activeVenueFilters.forEach(function (slug) {
        search.append('venue', slug);
      });
      var qs = search.toString();
      var newUrl = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', newUrl);
      }
    }

    function openFilterModal(trigger) {
      pendingScopeFilters = activeScopeFilters.slice();
      pendingVenueFilters = activeVenueFilters.slice();
      syncDrawerFilterState();

      lastFilterTrigger = trigger || lastFilterTrigger;
      filterPanel.hidden = false;
      filterPanel.setAttribute('data-filter-open', 'true');
      filterPanel.setAttribute('aria-hidden', 'false');

      scopeFilterTriggers.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'true');
      });

      if (scopeFilterBackdrop) {
        scopeFilterBackdrop.hidden = false;
        scopeFilterBackdrop.classList.add('is-visible');
      }
      root.setAttribute('data-scope-filter-open', 'true');
      document.body.style.overflow = 'hidden';
      syncFilterChrome();
    }

    function closeFilterModal(restoreFocus) {
      filterPanel.removeAttribute('data-filter-open');
      filterPanel.setAttribute('aria-hidden', 'true');
      filterPanel.hidden = true;

      scopeFilterTriggers.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });

      if (restoreFocus !== false && lastFilterTrigger) {
        lastFilterTrigger.focus();
      }

      if (scopeFilterBackdrop) {
        scopeFilterBackdrop.classList.remove('is-visible');
        scopeFilterBackdrop.hidden = true;
      }
      root.removeAttribute('data-scope-filter-open');
      document.body.style.overflow = '';
      syncFilterChrome();
    }

    function applyFilters() {
      activeScopeFilters = pendingScopeFilters.slice();
      activeVenueFilters = pendingVenueFilters.slice();
      closeFilterModal(true);
      renderAppliedFilters();
      syncFilterChrome();
      updateFilterUrl();
      applyGalleryFilter();
    }

    function removeAppliedFilter(kind, slug) {
      if (kind === 'venue') {
        var venueIndex = activeVenueFilters.indexOf(slug);
        if (venueIndex !== -1) activeVenueFilters.splice(venueIndex, 1);
      } else {
        var scopeIndex = activeScopeFilters.indexOf(slug);
        if (scopeIndex !== -1) activeScopeFilters.splice(scopeIndex, 1);
      }
      pendingScopeFilters = activeScopeFilters.slice();
      pendingVenueFilters = activeVenueFilters.slice();
      renderAppliedFilters();
      syncDrawerFilterState();
      syncFilterChrome();
      updateFilterUrl();
      applyGalleryFilter();
    }

    [tagNav, venueTagNav].forEach(function (nav) {
      if (!nav) return;
      nav.addEventListener('click', function (event) {
        var tag = event.target.closest('.ode-work-hub__tag');
        if (!tag) return;
        var kind = tag.getAttribute('data-filter-kind') || nav.getAttribute('data-filter-kind');
        var slug = tag.getAttribute('data-tag-value');
        var pendingList = kind === 'venue' ? pendingVenueFilters : pendingScopeFilters;
        var index = pendingList.indexOf(slug);
        if (index === -1) {
          pendingList.push(slug);
        } else {
          pendingList.splice(index, 1);
        }
        syncDrawerFilterState();
      });
    });

    if (appliedListEl) {
      appliedListEl.addEventListener('click', function (event) {
        var chip = event.target.closest('[data-remove-filter]');
        if (!chip) return;
        removeAppliedFilter(chip.getAttribute('data-remove-filter'), chip.getAttribute('data-filter-value'));
      });
    }

    scopeFilterTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        if (isFilterModalOpen()) {
          closeFilterModal(true);
        } else {
          openFilterModal(trigger);
        }
      });
    });

    if (scopeFilterClose) {
      scopeFilterClose.addEventListener('click', function () {
        closeFilterModal(true);
      });
    }
    if (scopeFilterBackdrop) {
      scopeFilterBackdrop.addEventListener('click', function () {
        closeFilterModal(true);
      });
    }
    if (filterClearBtn) {
      filterClearBtn.addEventListener('click', function () {
        pendingScopeFilters = [];
        pendingVenueFilters = [];
        syncDrawerFilterState();
      });
    }
    if (filterApplyBtn) {
      filterApplyBtn.addEventListener('click', function () {
        applyFilters();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isFilterModalOpen()) {
        closeFilterModal(true);
      }
    });

    if (typeof mobileScopeQuery.addEventListener === 'function') {
      mobileScopeQuery.addEventListener('change', syncFilterChrome);
    } else if (typeof mobileScopeQuery.addListener === 'function') {
      mobileScopeQuery.addListener(syncFilterChrome);
    }

    renderAppliedFilters();
    syncDrawerFilterState();
    syncFilterChrome();
    applyGalleryFilter();
  }

  function initRoot(root) {
    initNav(root);
    initCycle(root);
    initPropertyFilters(root);
  }

  function init() {
    document.querySelectorAll('[data-ode-work-hub]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-ode-work-hub]');
    if (root) initRoot(root);
  });
})();
